// © Microsoft Corporation. All rights reserved.

// These values should match those found in experiences-base/ColumnWidths.ts
const DefaultSize2ColumnWidth = 624;
const DefaultSize3ColumnWidth = 948;
const DefaultSize4ColumnWidth = 1272;

const contentBuffer = 32;

// The breakpoints to determine the breakpoint from
export const breakpoints: number[] = [
    0,
    DefaultSize2ColumnWidth + contentBuffer,
    DefaultSize3ColumnWidth + contentBuffer,
    DefaultSize4ColumnWidth + contentBuffer
];